import {AsyncPipe} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Observable} from 'rxjs';

@Component({
  template: `<b>You need to make some changes before submitting this form:</b>
    <ul>
      @for (problem of problems; track problem) {
        <li
          ><b>{{ problem.field }}:</b> {{ problem.message | async }}</li
        >
      }
    </ul>`,
  imports: [AsyncPipe],
})
export class ValidationErrorSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    params: {
      problems: {field: string; message: Observable<string>}[];
    },
  ) {
    this.problems = params.problems;
  }
  problems: {field: string; message: Observable<string>}[] = [];
}
